import React, {useCallback, useState} from "react";
import {StyledButton} from "../../../components";
import "./payment-form.css";
import classnames from "classnames";
import {ConfigProvider, Form, Tooltip} from "antd";
import {DISABLED_PAYMENT_INPUT_TITLE} from "./PaymentInput/consts.js";
import {FormInputV2} from "../../../components/form/index.jsx";
import {formatExpiry} from "./utils.js";

const errMessage = (msgs, c) => {
    let message = msgs.find(x => x === c);

    if (message) {
        return message;
    }
    return "";
};

const getError = err => {
    switch (err) {
        case "credit_card_number":
            return "מספר כרטיס אשראי לא תקין";
        case "expiry":
            return "תוקף כרטיס לא תקין";
        case "cvv":
            return "מספר לא תקין";
    }
};

const ErrorMsg = props => {
    const err = props.msg;

    if (!err || err === "") {
        return "";
    }

    const errorMessage = getError(err);
    return (
        <div className="cross-validation-error-message alert alert-danger">
            <span>{errorMessage}</span>
        </div>
    );
};

const PaymentHostedFieldsForm = ({msg, handleSubmit, loading, creditCardExist, disabled = false}) => {
    const [saveCard, setSaveCard] = useState(true);
    return (
        <form id="payment_form" onSubmit={e => handleSubmit(e, saveCard)}>
            <div className="payment-form-container">
                <div className="payment-form-inputs-container">
                    <div className="payment-form-input-card-num">
                        <div className="form-control" id="credit_card_num" />
                        <div id="errors_for_number" className="error_message" />
                        <ErrorMsg msg={errMessage(msg, "credit_card_number")} />
                    </div>
                    <div className="payment-form-input-card-expiry">
                        <div className="form-control" id="expiry" />
                        <div id="errors_for_expiry" className="error_message" />
                        <ErrorMsg msg={errMessage(msg, "expiry")} />
                    </div>
                    <div className="payment-form-input-card-cvv">
                        <div className="form-control" id="cvv" />
                        <div id="errors_for_cvv" className="error_message" />
                        <ErrorMsg msg={errMessage(msg, "cvv")} />
                    </div>
                    <ConfigProvider direction="rtl">
                        <Tooltip title={disabled ? DISABLED_PAYMENT_INPUT_TITLE : null}>
                            <StyledButton
                                disabled={disabled}
                                loading={loading}
                                className={classnames("payment-form-card-btn", {disabled})}
                                onClick={e => handleSubmit(e, saveCard)}>
                                {creditCardExist ? "החלפת כרטיס" : "הוספת כרטיס"}
                            </StyledButton>
                        </Tooltip>
                    </ConfigProvider>
                </div>
            </div>
        </form>
    );
};

const PaymentForm = ({handleSubmit, loading, creditCardExist, disabled = false}) => {
    const [form] = Form.useForm();

    const validationForm = useCallback(async () => {
        try {
            await form.validateFields();
            return true;
        } catch (e) {
            return false;
        }
    }, [form]);

    const onSave = useCallback(
        async creditCardData => {
            const isValidForm = await validationForm();

            if (!isValidForm) {
                return;
            }

            handleSubmit(creditCardData);
        },
        [form, handleSubmit, validationForm]
    );

    return (
        <Form id="payment_form" form={form} onFinish={onSave} validateTrigger="onSubmit">
            <ConfigProvider direction="rtl">
                <div className="payment-form-container">
                    <div className="payment-form-inputs-container">
                        <div className="payment-form-input-card-num">
                            <Form.Item name="creditCardNumber" rules={[{required: true, message: "שדה חובה"}]}>
                                <FormInputV2 id="credit_card_num" type="number" placeholder="מספר כרטיס אשראי" />
                            </Form.Item>
                        </div>
                        <div className="payment-form-input-card-expiry">
                            <Form.Item
                                getValueFromEvent={e => formatExpiry(e.target.value)}
                                name="expiry"
                                rules={[
                                    {required: true, message: "שדה חובה"},
                                    {
                                        validator: (_, value) => {
                                            if (!value) return Promise.resolve();

                                            const regex = /^(0[1-9]|1[0-2])\/(\d{2}|\d{4})$/;
                                            if (regex.test(value)) {
                                                return Promise.resolve();
                                            }

                                            return Promise.reject("תוקף לא תקין");
                                        }
                                    }
                                ]}>
                                <FormInputV2 id="expiry" placeholder="MM/YY" />
                            </Form.Item>
                        </div>
                        <div className="payment-form-input-card-cvv">
                            <Form.Item
                                name="cvv"
                                getValueFromEvent={e => e.target.value?.slice(0, 4)}
                                rules={[
                                    {required: true, message: "שדה חובה"},
                                    {
                                        pattern: /^\d{3,4}$/,
                                        message: "תוקף לא תקין"
                                    }
                                ]}>
                                <FormInputV2 id="cvv" type="number" placeholder="CVV" />
                            </Form.Item>
                        </div>

                        <Form.Item>
                            <Tooltip title={disabled ? DISABLED_PAYMENT_INPUT_TITLE : null}>
                                <StyledButton
                                    type="primary"
                                    htmlType="submit"
                                    disabled={disabled}
                                    loading={loading}
                                    className={classnames("payment-form-card-btn", {disabled})}>
                                    {creditCardExist ? "החלפת כרטיס" : "הוספת כרטיס"}
                                </StyledButton>
                            </Tooltip>
                        </Form.Item>
                    </div>
                </div>
            </ConfigProvider>
        </Form>
    );
};

export default PaymentForm;
